const px = (v) => `${v}px`;
export {
  px
};
